
(function () {

  function initCustomQuickAdd(container) {
    if (container.dataset.quickAddInitialized) return;
    container.dataset.quickAddInitialized = 'true';

    const productCard = container.closest('product-card');
    const variantsScript = container.querySelector('[data-product-variants]') || productCard?.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    const selects = container.querySelectorAll('.card-option-select');
    const addBtn = container.querySelector('[data-custom-add-to-cart]');
    const btnText = addBtn?.querySelector('[data-btn-text]');
    const priceSeparator = addBtn?.querySelector('[data-price-separator]');
    const priceWrapper = addBtn?.querySelector('[data-price-wrapper]');
    const loadingIcon = addBtn?.querySelector('[data-loading-icon]');
    const qtySelect = container.querySelector('[data-qty-select]');

    const isTrulySingleVariant = variants.length === 1 || container.hasAttribute('data-single-variant');

    if (!addBtn || !btnText) return;

    let selectedOptions = {};
    let currentVariant = null;

    selects.forEach(select => {
      selectedOptions[select.dataset.optionPosition] = select.value;
      select.addEventListener('change', function () {
        selectedOptions[this.dataset.optionPosition] = this.value;
        updateVariant();
      });
    });

    productCard.addEventListener('click', function (e) {
      if (
        e.target.closest('[data-product-card-swatch-button]') ||
        e.target.closest('.card-color-swatch') ||
        e.target.closest('.card-color-swatch--inner') ||
        e.target.closest('.swatch')
      ) {
        setTimeout(updateVariant, 60);
      }
    });

    if (qtySelect) {
      qtySelect.addEventListener('change', updatePriceDisplay);
    }

    function getCurrentColor() {
      const activeSwatch =
        productCard.querySelector('.card-color-swatch-input.swatch-selected') ||
        productCard.querySelector('.card-color-swatch--inner.swatch-selected') ||
        productCard.querySelector('[data-product-card-swatch-button].active') ||
        productCard.querySelector('.swatch-selected') ||
        productCard.querySelector('input[type="radio"].card-color-swatch-input:checked');

      if (!activeSwatch) return null;

      const colorValue =
        activeSwatch.dataset.colorValue ||
        activeSwatch.closest('[data-color-value-full]')?.dataset.colorValueFull ||
        activeSwatch.closest('.card-color-swatch--inner')?.dataset.colorValue ||
        activeSwatch.value ||
        activeSwatch.getAttribute('data-value') ||
        activeSwatch.getAttribute('aria-label') ||
        activeSwatch.getAttribute('title');
     
      return colorValue ? colorValue.trim() : null;
    }
    function findMatchingVariant() {
      if (isTrulySingleVariant) {
        return variants[0] || null;
      }
      const currentColor = getCurrentColor();
        return variants.find(variant => {
        const optionsMatch = Object.keys(selectedOptions).every(pos => {
          return variant[`option${pos}`] === selectedOptions[pos];
        });

        if (!optionsMatch) return false;

        if (currentColor) {
          return (
            variant.option1 === currentColor ||
            variant.option2 === currentColor ||
            variant.option3 === currentColor
          );
        }

        return true;
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
    }

    function updatePriceDisplay() {
      
      const priceContainer = addBtn?.querySelector('[data-price-wrapper]') || addBtn?.querySelector('.product-grid--price');
      if (!priceContainer || !currentVariant) return;

      const quantity = qtySelect ? Number(qtySelect.value) : 1;
      const price = currentVariant.price * quantity;
      const compareAt = currentVariant.compare_at_price ? currentVariant.compare_at_price * quantity : null;

      const regularPriceEl = priceContainer.querySelector('.product-price--regular');
      const salePriceEl = priceContainer.querySelector('.price--sale-price');
      const comparePriceEl = priceContainer.querySelector('.price--compare-at-price');
      const saleWrapper = priceContainer.querySelector('.product-price--sale');

      if (compareAt && compareAt > price) {
        if (saleWrapper) saleWrapper.classList.remove('hidden');
        if (regularPriceEl) regularPriceEl.style.display = 'none';
        if (salePriceEl) salePriceEl.textContent = formatMoney(price);
        if (comparePriceEl) {
          comparePriceEl.innerHTML = `<span class="visually-hidden">Regular price</span>${formatMoney(compareAt)}`;
        }
      } else {
        if (saleWrapper) saleWrapper.classList.add('hidden');
        if (regularPriceEl) {
          regularPriceEl.style.display = '';
          regularPriceEl.textContent = formatMoney(price);
        }
        if (!regularPriceEl && !salePriceEl) {
          const moneyEl = priceContainer.querySelector('.money') || priceContainer;
          if (moneyEl) moneyEl.textContent = formatMoney(price);
        }
      }
    }

    function updateVariant() {
      const matchedVariant = findMatchingVariant();
      currentVariant = matchedVariant;

      if (!matchedVariant) {
        
        addBtn.disabled = true;
        btnText.textContent = 'Unavailable';
        delete addBtn.dataset.variantId;
        return;
      }

      addBtn.dataset.variantId = matchedVariant.id;

      if (matchedVariant.available) {
        addBtn.disabled = false;
        btnText.textContent = 'ADD TO CART';
      } else {
        addBtn.disabled = true;
        btnText.textContent = 'SOLD OUT';
      }

 

      updatePriceDisplay();
    }

    function showLoading() {
      if (btnText) btnText.style.display = 'none';
      if (priceSeparator) priceSeparator.style.display = 'none';
      if (priceWrapper) priceWrapper.style.display = 'none';
      if (loadingIcon) loadingIcon.style.display = 'inline-flex';
      if (loadingIcon) loadingIcon.classList.add('active');
      addBtn.disabled = true;
    }

    function hideLoading(finalText = 'ADD TO CART') {
      if (loadingIcon) loadingIcon.style.display = 'none';
      if (loadingIcon) loadingIcon.classList.remove('active');
      if (btnText) {
        btnText.style.display = '';
        btnText.textContent = finalText;
      }
      if (priceSeparator) priceSeparator.style.display = '';
      if (priceWrapper) priceWrapper.style.display = '';
      addBtn.disabled = false;
    }

    updateVariant();

    addBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = this.dataset.variantId;
      if (!variantId || this.disabled) return;

      const quantity = qtySelect ? Number(qtySelect.value) : 1;

      showLoading();

      const requestBody = {
        id: Number(variantId),
        quantity: quantity
      };

      if (currentVariant?.requires_selling_plan) {
        const sellingPlanId = container.dataset.defaultSellingPlan;
        if (sellingPlanId) {
          requestBody.selling_plan = Number(sellingPlanId);
        }
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        if (!response.ok) throw new Error('Add to cart failed');
        await response.json();

        hideLoading();
        Array.prototype.forEach.call(document.querySelectorAll('.cart-item-count-header--quantity'), el => {
        el.classList.remove('hide');
      });
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(() => {
          hideLoading('ADD TO CART');
          updatePriceDisplay();
        }, 1500);

      } catch (error) {
        console.error(error);
        hideLoading('Error');
        setTimeout(() => {
          hideLoading('ADD TO CART');
          updatePriceDisplay();
        }, 1500);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-custom-quick-add]').forEach(el => {
      delete el.dataset.quickAddInitialized;
      initCustomQuickAdd(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('[data-custom-quick-add]')) {
          initCustomQuickAdd(node);
        }
        node.querySelectorAll?.('[data-custom-quick-add]').forEach(initCustomQuickAdd);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
document.addEventListener('click', function (event) {
    const form_data = event.target.closest('#CollectionFiltersForm');
    if (form_data) {
        setTimeout(function () {
            initAll();
        }, 400);
    }
});
  window.addEventListener('pageshow', initAll);

  document.addEventListener('theme:filters:update', initAll);
  document.addEventListener('facet:update', initAll);
  document.addEventListener('collection:updated', initAll);

})();
